// Empty post template used by the blog editor. Authentication tokens are no
// longer stored client-side — admin sessions are managed via HttpOnly cookies
// issued by the backend on /api/admin/login.
export const EMPTY_POST = {
  title: "",
  excerpt: "",
  content: "",
  category: "Insight",
  cover_image: "",
  author: "Danny Clans Media",
  published: true,
  locale: "en",
};
